import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    container: {
      backgroundColor: '#ffffff',
      borderRadius: '4px 4px 4px 4px',
      padding: theme.spacing(3),
      width: '100%',
    },
    licenseTitle: {
      margin: '12px 0',
      fontSize: '16px',
      fontWeight: 700,
    },
    container1: {
      marginTop: '12px',
      backgroundColor: '#ffffff',
      borderRadius: '4px 4px 4px 4px',
      padding: theme.spacing(3),
      width: '100%',
    },
    block: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: theme.spacing(0, 4, 0, 0),
      '@media (max-width: 1349px)': {
        maxWidth: '100%',
        flexBasis: '100%',
      },
    },
    row: {
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(3.5),
    },
    title: {
      padding: 5,
      fontSize: 14,
      letterSpacing: 0.15,
      color: 'rgb(0 0 0 / 54%)',
      '@media (min-width: 1350px)': {
        width: '45%',
      },
    },
    desc: {
      fontSize: 16,
      width: '55%',
      borderBottom: '1px solid #E0E0E0',
      padding: 5,
      //color: 'rgb(0 0 0 / 54%)',
    },
    gridPaper: {
      height: '100%',
    },
    tabsPanel: {
      width: '60%',
    },
    descRed: {
      color: '#ff505f',
      marginRight: theme.spacing(2.5),
    },
    dark: {
      color: 'rgb(0 0 0 / 87%)',
    },
    btnBox: {
      display: 'flex',
      justifyContent: 'flex-start',
      //marginTop: theme.spacing(1),
    },
    btn: {
      padding: theme.spacing(1, 3.5),
      //marginRigth: theme.spacing(3),
      margin: theme.spacing(2, 3, 0, 0),
      fontSize: 14,
      textTransform: 'none',
    },
  }),
  {
    index: 1,
  }
);
